const hours = [
  ["Segunda-feira", "06:00 - 11:00", "13:00 - 21:00"],
  ["Terça-feira", "06:00 - 11:00", "13:00 - 21:00"],
  ["Quarta-feira", "06:00 - 11:00", "13:00 - 21:00"],
  ["Quinta-feira", "06:00 - 11:00", "13:00 - 21:00"],
  ["Sexta-feira", "06:00 - 11:00", "13:00 - 21:00"],
];

export const Horarios = () => {
  return (
    <section id="about" className="about">
      <div className="container" data-aos="fade-up">
        <div className="section-title">
          <h2>Horários de Atendimento</h2>
        </div>

        <div className="row content justify-content-center">
          <div className="table-responsive" style={{ maxWidth: 600 }}>
            <table className="table table-bordered text-center">
              <thead className="thead-dark">
                <tr>
                  <th>Dia</th>
                  <th>Manhã</th>
                  <th>Tarde</th>
                </tr>
              </thead>
              <tbody>
                {hours.map(([dia, manha, tarde], index) => (
                  <tr key={index}>
                    <td>{dia}</td>
                    <td>{manha}</td>
                    <td>{tarde}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div className="text-center">
            <p>
              <strong>Endereço: </strong>R. José Borges de Araújo, 341 - Vila
              Santa Luzia. <br />
              Araxá - MG, 38184-066
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};
